export default __webpack_public_path__ + "static/media/white_bill_icon.8fee4a81.svg";